<ngx-asset-tree
  [showLoadingSpinner]="assetTreeLoading$ | async"
  [useContextMenu]="true"
  [editable]="true"
  [showHiddenAssets]="false"
  (assetSelected)="setAssetIdForCurrentUrl($event?.assetId)"
/>
